import React from "react";
import { COMMEND3_TITLE, NOT_YET_AVAILABLE } from "../Commend3Constants";

type Commend3HeaderProps = {
  createEnabled: boolean;
  onCreate: () => void;
  createUnavailableReason?: string;
};

const HistoryIcon = () => (
  <svg
    viewBox="0 0 24 24"
    className="tw-h-4 tw-w-4"
    style={{
      stroke: "currentColor",
      fill: "none",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round",
    }}
    aria-hidden="true"
  >
    <path d="M3 3v5h5" />
    <path d="M3.05 13A9 9 0 1 0 6 5.3L3 8" />
    <path d="M12 7v5l4 2" />
  </svg>
);

const DISABLED_OUTLINE: React.CSSProperties = {
  border: "0.5px solid #E3E5EC",
  background: "#fff",
  color: "#B4B9D4",
  cursor: "not-allowed",
};

const Commend3Header = ({
  createEnabled,
  onCreate,
  createUnavailableReason,
}: Commend3HeaderProps) => (
  <div
    id="commend3-header"
    className="tw-flex tw-h-[54px] tw-shrink-0 tw-items-center tw-gap-2.5 tw-bg-white tw-px-[22px]"
    style={{ borderBottom: "0.5px solid #E3E5EC" }}
  >
    <span
      className="tw-text-[18px] tw-font-semibold tw-text-[#030562]"
      style={{ letterSpacing: "-0.025em" }}
    >
      {COMMEND3_TITLE}
    </span>

    <div className="tw-flex-1" />

    <span className="tw-inline-flex tw-shrink-0" title={NOT_YET_AVAILABLE}>
      <button
        id="commend3-btn-activity-log"
        type="button"
        className="tw-relative tw-flex tw-shrink-0 tw-items-center tw-rounded-md tw-px-[9px] tw-py-1.5"
        style={DISABLED_OUTLINE}
        disabled
        aria-label="Activity log"
      >
        <HistoryIcon />
      </button>
    </span>

    <span className="tw-inline-flex tw-shrink-0" title={NOT_YET_AVAILABLE}>
      <button
        id="commend3-btn-map-widget"
        type="button"
        className="tw-inline-flex tw-shrink-0 tw-items-center tw-gap-[5px] tw-whitespace-nowrap tw-rounded-md tw-px-[14px] tw-py-[7px] tw-text-[13px] tw-font-medium"
        style={DISABLED_OUTLINE}
        disabled
      >
        Map widget
      </button>
    </span>

    <span className="tw-inline-flex tw-shrink-0" title={NOT_YET_AVAILABLE}>
      <button
        id="commend3-btn-promote"
        type="button"
        className="tw-inline-flex tw-shrink-0 tw-items-center tw-gap-[5px] tw-whitespace-nowrap tw-rounded-md tw-px-[14px] tw-py-[7px] tw-text-[13px] tw-font-medium"
        style={DISABLED_OUTLINE}
        disabled
      >
        Promote
      </button>
    </span>

    <span
      className="tw-inline-flex tw-shrink-0"
      title={createEnabled ? undefined : createUnavailableReason}
    >
      <button
        id="commend3-btn-create"
        type="button"
        className="tw-inline-flex tw-items-center tw-gap-[5px] tw-whitespace-nowrap tw-rounded-md tw-px-[14px] tw-py-[7px] tw-text-[13px] tw-font-medium"
        style={{
          border: "0.5px solid transparent",
          background: "#030562",
          color: "#FFFFFF",
          cursor: createEnabled ? "pointer" : "not-allowed",
          opacity: createEnabled ? 1 : 0.5,
        }}
        disabled={!createEnabled}
        onClick={onCreate}
      >
        + Create
      </button>
    </span>
  </div>
);

export default Commend3Header;
